import { render, staticRenderFns } from "./VocabularyPracticePage.vue?vue&type=template&id=900636be&"
import script from "./VocabularyPracticePage.vue?vue&type=script&lang=js&"
export * from "./VocabularyPracticePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports